export default __webpack_public_path__ + "static/media/veiw-notes.f70401e5.svg";